import { RowCell } from 'modules/_shared/Table/types/RowCell';
import { ReactNode } from 'react';

export const buildCells = ({
  index,
  expandContent,
  partnerContent,
  className,
  from,
  to,
  shares,
}: {
  index: number | string;
  expandContent: ReactNode;
  partnerContent: ReactNode;
  className: ReactNode;
  from: ReactNode;
  to: ReactNode;
  shares: ReactNode;
}): RowCell[] =>
  [
    { key: `expand-${index}`, content: expandContent },
    { key: `partner-${index}`, content: partnerContent },
    { key: `class-${index}`, content: className },
    { key: `from-${index}`, content: from, textPosition: 'right' },
    { key: `to-${index}`, content: to, textPosition: 'right' },
    { key: `shares-${index}`, content: shares, textPosition: 'right' },
  ] as RowCell[];
